import React, { useEffect, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Col, Container, Row, Table } from "react-bootstrap";
import SelectDropDown from "../component/SelectDropDown";
import RegistrationService from "../services/registration";
import OrderService from "../services/Order";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../component/Loader";
import Button from "react-bootstrap/Button";
import NoData from "../component/NoData";
import AddressContext from "../context/AddressContext";
import toast from "react-hot-toast";
import PurchaseService from "../services/Purchase";
import { Flex } from "antd";
import ConfirmationModal from '../component/ConfirmationModal'
import GridModal2 from "../component/Modals/GridModal2";

const AddressApprovalListing = () => {
  const navigate = useNavigate();

  const [persona, setPersona] = useState([]);
  const [selectedPersona, setSelectedPersona] = useState({
    id: "",
    title: "",
  });
  const [findUser, setFindUser] = useState({
    id: "",
    title: "",
    phoneNo: "",
    country: "",
    state: "",
    district: "",
    taluka: "",
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    postCode: "",
    districtId: "",
    talukId: "",
    brandId: "",
    contactId: "",
    panNo: "",
    panImage: "",
    aadharNo: "",
    aadharImageFront: "",
    aadharImageBack: "",
    voterId: "",
    voterImageFront: "",
    voterImageBack: "",
    dlNo: "",
    dlImageFront: "",
    dlImageBack: "",
    profilePic: "",
  });
  const [loading, setLoading] = useState(false);
  const [orderList, setOrderList] = useState([]);
  const [error, setError] = useState("");
  const [btnDisable, setBtnDisable] = useState(false);
  const allStatus = [
    { id: "pending", title: "Pending", pageNo: 1 },
    { id: "accepted", title: "Approved / Rejected", pageNo: 1 },
  ];
  // const [status, setStatus] = useState(allStatus[0]);
  const [status, setStatus] = useState({pageNo: 1});
  const [isTableDataFound, setIsTableDataFound] = useState(false);
  const [pageNo, setPageNo] = useState(1);

    const [line1, setLine1] = useState("");       
    const [line2, setLine2] = useState("");       
    const [line3, setLine3] = useState("");       
    const [pincode, setPincode] = useState("");   
    const [selectedState, setSelectedState] = useState({ id: "", title: "" });      
    const [selectedDistrict, setSelectedDistrict] = useState({ id: "", title: "" }); 
    const [order_id, setOrder_id] = useState("");
    const [address_id, setAddress_id] = useState("");
    const [selectedResidence, setSelectedResidence] = useState({ id: "", title: "" });
    const [isEditable, setEditable] = useState(false);

    const [pagination, setPagination] = useState({
      currentPage: 1,
      totalPages: 1,
      totalRecords: 0,
      limit: 10,
    });
    const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    const memberTypeResponse = async () => {
      try {
        const selectedOrg = 2;
        const MemberTypeFetch = await RegistrationService.getHierarchies(
          selectedOrg
        );
        if (
          MemberTypeFetch.success === true &&
          MemberTypeFetch.response.hierarchiesDetails.length > 0
        ) {
          const allHierarchies = MemberTypeFetch.response.hierarchiesDetails;
          const contractorOnly = allHierarchies
            .filter((item) => item.name === "CONTRACTOR")
            .map((item) => ({
              id: item.id,
              title: item.name,
            }));
          setPersona(contractorOnly);
          setLoading(false);
        }
      } catch (e) {
      }
    };
    memberTypeResponse();
  }, []);

  const handlePersonaChange = (selectedValue) => {
    setSelectedPersona(selectedValue);
    localStorage.setItem("selectedOption", JSON.stringify(selectedValue));
  };

  const {state} = useLocation();

  useEffect(() => {
    if (state) {
      setSelectedPersona(state);
    }
  }, [state]);

  function resetFindUser() {
    setFindUser({
      id: "",
      title: "",
      phoneNo: "",
      country: "",
      state: "",
      district: "",
      taluka: "",
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      postCode: "",
      districtId: "",
      talukId: "",
      brandId: "",
      contactId: "",
      panNo: "",
      panImage: "",
      aadharNo: "",
      aadharImageFront: "",
      aadharImageBack: "",
      voterId: "",
      voterImageFront: "",
      voterImageBack: "",
      dlNo: "",
      dlImageFront: "",
      dlImageBack: "",
      profilePic: "",
    });
  }

  function onLoadMore() {
    
    setStatus((p) => ({ ...p, pageNo: p.pageNo + 1 }));
  }

  // useEffect(() => {
    const ListFetch = async () => {
      setLoading(true);
      try {
      // if (pageNo == 1){
        const payload = {
          userHierarchyId: selectedPersona.id,
          page_no: status?.pageNo,

        };
        
        const ListDataFetchResponse = await OrderService.getAddressList(
          payload,
          // status?.pageNo,
        );
        
        if (
          ListDataFetchResponse.status === true &&
          ListDataFetchResponse.data?.orders
        ) {
          if(status.pageNo === 1) {
            setOrderList(ListDataFetchResponse.data.orders);
          } else {
            setOrderList((prev) => [
              ...prev,
              ...ListDataFetchResponse.data.orders,
            ])
          }
          setPagination(ListDataFetchResponse.data.pagination);
        } else {
          setOrderList([]);
        }
        // } 
       }catch (e) {
          setError("Failed to fetch address list");
        } finally {
          setLoading(false);
        } 
      
    };

  //   if (selectedPersona.id) {
  //     ListFetch();
  //   }
  // }, [selectedPersona, findUser]);

  useEffect(() => {
    if (selectedPersona.id) {
      ListFetch();
    }
  }, [selectedPersona, findUser, status.pageNo]);

  let headers = [];
  if (orderList.length > 0) {
    headers = [
      "Order Id",
      "Name",
      "Address",
      // "Line 1",
      // "Line 2",
      // "Line 3",
      // "City",
      // "City Name",
      "State",
      "District",
      "Post Code",
      "Action",
    ];
  }

  const handleEdit = (item) => {
    navigate(`/address-approval/${item.order_id}`, {
      state: { addressData: item },
    });
  };

   const savePurchase = async (item) => {
    // const selectedOption = localStorage.getItem("selectedOption");
    
      const payload = {
      orderId: item.order_id,
      addressId: item.address_id,
      status: "modify",
      addressType: "residential",
      line1: item.line1,                      
      line2: item.line2,                      
      line3: item.line3,                      
      city: item.city,  
      districtId: item.district_id, 
      stateId: item.state_id,       
      countryId: 100,
      pincode: item.post_code,                    
    };
  

    

    if (!payload.orderId || !payload.addressId || !payload.pincode || !payload.line1 || !payload.addressType) {
      toast.error("Please select all the required fields");
      return;
    }

    try {
      setLoading(true);
      // const res = null
      const res = await PurchaseService.updateAddress(payload);
      setIsApproveModalOpen(false);
      setLoading(false);
      if (res.success) {
        toast.success("Approved successfully");
        setEditable(false);

        await ListFetch(); 
        // setOrderList(prev=>prev.filter(order => order.order_id !== item.order_id))
        // setTimeout(() => navigate(`/address-approval-list`, {state: JSON.parse(localStorage.getItem('selectedOption'))}), 1500);
      }
    } catch (err) {
      setLoading(false);
      toast.error("Something went wrong. Please try again.");
    }
  // }
  };

  const handleApproveClick = (item) => {
    setSelectedItem(item);
    setIsApproveModalOpen(true);
};

  return (
    <AddressContext.Provider
      value={{ orderList, setOrderList, loading, selectedPersona }}
    >
      <>
        {/* {loading && <Loader />} */}
        <BreadCrumbSecttion
          pageTitle="Address Approval"
          currentPageName="Address Approval"
        />
        <section className="padTop50">
          <Container>
            <Row>
              <Col xs={12}>
                <div className="searchBoxBlock my-4">
                  <Row>
                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="Member Type"
                        requiredStar="*"
                        options={persona}
                        onChange={handlePersonaChange}
                        selectedValue={selectedPersona}
                        setSelectedValue={setSelectedPersona}
                        page="searchFilter"
                      />
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>

          <Container>
            {!loading && selectedPersona.id && orderList.length === 0 && <NoData />}
            {orderList.length === 0 && loading && <NoData title="fetching.." />}
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  {headers.length > 0 &&
                    headers.map((header, index) => (
                      <th key={index}>{header}</th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {orderList.length > 0 &&
                  orderList.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <div>{item["order_id"]}</div>
                        </td>

                        <td>
                          <div>{item["contractor_name"]}</div>
                          <div>Mob: {item["contractor_phone"]}</div>
                          <div>Member code: {item["external_id"]}</div>

                        </td>

                        {/* <td>
                          <div>{item["line1"]}</div>
                        </td>

                        <td>
                          <div>{item["line2"]}</div>
                        </td>

                        <td>
                          <div>{item["line3"]}</div>
                        </td> */}

                        <td>
                          <div>
                            {[item.line1, item.line2, item.line3]
                              .filter(line => line && line.trim() !== "")
                              .join(", ")}
                          </div>
                        </td>

                        {/* <td>
                          <div>{item["city"]}</div>
                        </td> */}

                        {/* <td>
                              <div>{item["city_name"]}</div>
                            </td> */}

                        <td>
                          <div>{item["state_name"]}</div>
                        </td>

                        <td>
                          <div>{item["district_name"]}</div>
                        </td>

                        <td>
                          <div>{item["post_code"]}</div>
                        </td>

                        <td>
                          <div>
                            {/* <Row className="mt-3">
                              <Col xs={12} lg={12}>
                                <Button
                                  variant="warning"
                                  className="w-100 h-48"
                                  onClick={() => handleAction(item)}
                                >
                                  Approve
                                </Button>

                                <Button
                                  variant="warning"
                                  className="w-100 h-48"
                                  onClick={() => handleAction(item)}
                                >
                                  Edit
                                </Button>
                              </Col>
                            </Row> */}
                            {/* <Button
                                  className="checkNowBtn"
                                  onClick={() => savePurchase(item)}
                                >
                                  Approve
                                </Button> */}
                            <div style={{display: "flex"}}>
                              <PrimaryGradientButton
                                buttonText={"Approve"}
                                // onClick={() => savePurchase(item)}
                                onClick={() => {
                                  handleApproveClick(item)
                                  setSelectedItem(item);  
                                }}
                              />
                              &nbsp;
                              <PrimaryGradientButton
                                buttonText={"Edit"}
                                onClick={() => handleEdit(item)}
                              />
                              </div>
                                {/* <Button
                                  // variant="warning"
                                  className="checkNowBtn"
                                  onClick={() => handleEdit(item)}
                                >
                                  Edit
                                </Button> */}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>

            {orderList.length > 0 && !loading && pagination.currentPage < pagination.totalPages && (
              <Container>
                <Row className="justify-content-center">
                  <Col xs={12} lg={3}>
                    <PrimaryGradientButton
                      disabled={btnDisable}
                      onClick={onLoadMore}
                      buttonText="Show More"
                    />
                  </Col>
                </Row>
              </Container>
            )}

            <GridModal2
              show={isApproveModalOpen}
              setShow={setIsApproveModalOpen}
              title="Are you sure you want to approve this purchase?"
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <PrimaryGradientButton
                  buttonText={"Yes"}
                  onClick={() => savePurchase(selectedItem)}
                /> &nbsp; &nbsp;
                <PrimaryGradientButton
                  buttonText={"No"}
                  onClick={() => setIsApproveModalOpen(false)}
                />
              </div>
            </GridModal2>

          </Container>
        </section>
      </>
    </AddressContext.Provider>
  );
};

export default AddressApprovalListing;
